export function smoothScroll( event ){
    event.preventDefault();
    let target = new URL( event.target.href ).hash || '#top';
    let element = document.querySelector(target);
    if( element ){
        element.scrollIntoView({ behavior: 'smooth' });
    }
}

export function map( value, start1, stop1, start2, stop2, withinBounds ){
    const newval = (value - start1) / (stop1 - start1) * (stop2 - start2) + start2;
    if (!withinBounds) {
        return newval;
    }
    if (start2 < stop2) {
        return this.constrain(newval, start2, stop2);
    } else {
        return this.constrain(newval, stop2, start2);
    }
};

export function formatDate( dateAsString = '1999-01-01' ){
    let date = new Date( dateAsString );
    return date.toLocaleDateString('de-DE', {
        weekday: 'short',
        day: 'numeric',
        month: 'numeric',
        year: '2-digit'
    });
}

export function sortByDate( a, b ) {
    if ( a.date < b.date ){
        return -1;
    }
    if ( a.date > b.date ){
       return 1;
    }
    return 0;
}

export function slugify( str ){
    str = String(str);
    str = str.trim();
    str = str.toLowerCase();
    str = str.replace(/ä/g, 'ae');
    str = str.replace(/ö/g, 'oe');
    str = str.replace(/ü/g, 'ue');
    str = str.replace(/ß/g, 'ss');
    str = str.replace(/\s+/g,'-');
    str = str.replace(/[^\w-]+/g,'');
    return str;
}

export function roundGeo( fl, precision = 100000 ){
    fl = fl * precision;
    fl = Math.round( fl );
    fl = fl / precision;
    return fl;
}

export function serializeSchema(thing) {
    return `<script type="application/ld+json">${JSON.stringify(thing)}</script>`;
}